import {PartSelectableObjectLogo} from "./partSelObLogo";
import type {ChromoLogo} from "./selectableObjects";
import {EventVerteiler} from "../global/eventVerteiler";
import {CONSTANTS} from "./meta_data";
import {Canvg} from "canvg";
import {warnIfDebug} from "../global/logFunctions";
import {SelObTypes} from "./SelObTypes";

export class PartSelectableObjectChromoLogo extends PartSelectableObjectLogo {
    private svg;
    public farbkombinationen;
    public type=SelObTypes.CHROMOLOGO;

    constructor(params) {
        super(params);
        this.svg = params.svg;
        this.farbkombinationen = params.farbkombinationen
    }

    reInitialize(selOb: ChromoLogo) {
        this.svg = selOb.currentSVG;
        this.getParent().pendingTasks.addTasks(1);
        this.setViewerTask();
        this.init();
    }

    init(callback?): Promise<void> {
        const $this = this;
            return new Promise<void>((resolve) => {


            const canvas: HTMLCanvasElement = document.createElement('canvas');
        canvas.width = CONSTANTS.CHROMOLOGOCANVASWIDTH;
        canvas.height = CONSTANTS.CHROMOLOGOCANVASWIDTH;

        const  v = Canvg.fromString(
            canvas.getContext("2d") as CanvasRenderingContext2D,
            this.svg,
            {
                ignoreMouse: true,
                ignoreAnimation: true,
                // useCORS : true,
                // noRenderLoop : true
            }
        );
        v.start();

        const imageObj = new Image();
            imageObj.onload = function () {
            $this.imageObjectLoaded(imageObj);
                EventVerteiler.broadcast("ChromoLogoImageCreatedEvent", {image: this, isPattern: $this.isPattern});
                imageObj.onload = null;
                imageObj.onerror=null;
                if (typeof (callback) === "function") {
                callback();
            }
            $this.svg = "";
            $this.viewerTaskFinished();
                resolve();
        };
            imageObj.onerror = function () {
            warnIfDebug("could not Load Logo Image");
            $this.viewerTaskFinished();
            imageObj.onload=null;
            imageObj.onerror=null;

        };
            if (this.svg.indexOf("base64") > -1) {
                setTimeout(() => {
                    imageObj.src = canvas.toDataURL("image/png");
                }, 500);
        } else {
            imageObj.src = canvas.toDataURL("image/png");
        }
        });
    }
}
